import { appConfig } from "../config";

export interface PolymarketMarket {
  slug?: string;
  outcomes?: string;
  outcomePrices?: string;
}

export function polymarketEmbedSrc(
  slug?: string,
  height = 300,
): string | undefined {
  const trimmed = slug?.trim();
  if (!trimmed) return undefined;

  const params = new URLSearchParams({
    market: trimmed,
    volume: "false",
    buttons: "false",
    border: "true",
    height: String(height),
  });

  return `${appConfig.polymarket.embedBaseUrl}?${params.toString()}`;
}

export function polymarketOddsUrl(slugs: string[]): string {
  if (slugs.length === 0) return appConfig.polymarket.gammaMarketsUrl;

  const params = new URLSearchParams();
  slugs.forEach((slug) => params.append("slug", slug));
  // Gamma returns only 20 markets by default; request enough to cover
  // every queried slug, or distant teams silently fall back to "—".
  params.set("limit", String(slugs.length));

  return `${appConfig.polymarket.gammaMarketsUrl}?${params.toString()}`;
}

export function parseYesPrice(market: PolymarketMarket): number | undefined {
  const outcomes = safeParseStringArray(market.outcomes);
  const prices = safeParseStringArray(market.outcomePrices);
  if (!outcomes || !prices) return undefined;

  if (outcomes.length !== prices.length) return undefined;

  const yesIndex = outcomes.findIndex(
    (outcome) => outcome.toLowerCase() === "yes",
  );
  if (yesIndex < 0) return undefined;

  const price = Number(prices[yesIndex]);
  return Number.isFinite(price) ? price : undefined;
}

function safeParseStringArray(value?: string): string[] | undefined {
  if (!value) return undefined;

  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(String) : undefined;
  } catch {
    return undefined;
  }
}
